// extracted by mini-css-extract-plugin
export default {"cls1":"sQ9HpLedLbQ3C5yu9CXf","cls2":"pyj8yAsWlxAZ9MNuCyFr sQ9HpLedLbQ3C5yu9CXf","isDesktopUp":"p8NtczWCZyZCij4e3kbd"};